import moment from "moment";
import File from "./file";

export interface IItem {
  item_code?: number;
  item_name: string;
  description: string;
  item_name_1: string;
  item_name_2: string;
  item_category: ItemCategory;
  files: File[];
  is_enabled: boolean;
  item_carton: ItemCarton;
  created: string;
  shop_price: number;
  user_price: number;
  min_order_amount: number;
  max_order_quantity: number;
}

export interface ItemCarton {
  item_carton_code?: number;
  item_code: number;
  item_name_1: string;
  item_name_2: string;
  carton_description: string;
  unit_quantity: number;
  unit_name: string;
  can_deliver_today: boolean;
  created: string;
  delivery_day_inquiry_kbn: number;
}

export class ItemCategoryDTO {
  item_category_code?: number;
  name: string;
  display_order: number;
  created?: string;
}

export class ItemCategory extends ItemCategoryDTO {
  item_category_code?: number;
  name: string;
  display_order: number;
  created?: string;
  constructor(dto: ItemCategoryDTO) {
    super();
    Object.assign(this, dto);
  }
}

export class ItemDTO implements IItem {
  item_code?: number;
  item_name: string;
  item_name_1: string;
  item_name_2: string;
  description: string;
  item_category: ItemCategory;
  files: File[];
  is_enabled: boolean;
  item_carton: ItemCarton;
  item_images: ItemCarton;
  created: string;
  shop_price = 0;
  user_price = 0;
  min_order_amount = 1;
  max_order_quantity = 1;
}

import { DATE_TIME_FORMAT } from "@/common/constant";

export default class Item extends ItemDTO {
  createdDateTime;

  constructor(dto: ItemDTO) {
    super();
    Object.assign(this, dto);
    this.createdDateTime = moment(this.created);
  }

  get createdAt(): string {
    return this.createdDateTime.format(DATE_TIME_FORMAT);
  }

  get getItemName(): string {
    return this.item_name_1 + " " + this.item_name_2;
  }

  get getPrice(): string {
    return new Intl.NumberFormat().format(this.shop_price);
  }

  get getPriceIncludeTax(): string {
    return new Intl.NumberFormat().format(this.user_price);
  }

  get getDescription(): string {
    return "NO." + this.item_code;
  }

  get getCategoryName(): string {
    return this.item_category.name || "";
  }

  get getImageUrl(): string {
    if (this.files && this.files[0]) {
      return this.files[0].file_path_full;
    }

    return "";
  }
}
